import { Button as ButtonComponent } from 'components/Button';
import { ArrowLeftIcon } from 'components/icons/ArrowLeftIcon';
import { ArrowRightIcon } from 'components/icons/ArrowRightIcon';
import { Box } from 'ui/Box';
import { FC } from 'react';
import { Typography } from 'ui/Typography';

export interface ButtonProps {
  variant: 'next' | 'back';
  onClick: () => void;
  className?: string;
  disabled?: boolean;
}
export const Button: FC<ButtonProps> = ({
  variant,
  onClick,
  className,
  disabled = false,
}) => {
  const classes = `w-full max-w-48 px-0 ${className}`;

  return (
    <ButtonComponent
      onClick={onClick}
      disabled={disabled}
      variantType="outlined"
      className={classes}
    >
      <Box className="color-blue flex items-center gap-3">
        {variant === 'back' && <ArrowLeftIcon className="h-5 w-5 text-blue" />}
        <Typography>{variant === 'next' ? 'Next' : 'Back'}</Typography>
        {variant === 'next' && <ArrowRightIcon className="h-5 w-5" />}
      </Box>
    </ButtonComponent>
  );
};
